import program from './program2022.json';

export const SEEDF_COURSE_ID = 'seedf-gestor-administracao';
export const SEEDF_SOURCE = {
  sourceTitle: 'SEEDF — Edital nº 31, de 30/06/2022, Anexo IV; retificação nº 36/2022',
  sourceUrl: 'https://quadrix.org.br/informacoes/1180/',
  sourceDocument: 'docs/sources/seedf/DODF-122-2022.pdf',
  officialPublisher: 'Secretaria de Estado de Educação do Distrito Federal', organizer: 'Instituto Quadrix',
  sourceYear: 2022, sourceType: 'EDITAL_DE_REFERENCIA_HISTORICO',
  referenceStatus: 'VERIFIED', verifiedAt: '2026-11-04',
  futureNoticeStatus: 'NOT_ADOPTED',
  referenceWarning: 'Referência de 2022, com retificações. Não é o edital definitivo de concurso futuro. Normas posteriores exigem nova revisão.'
};
export const SEEDF_ROLES = [
  { id: SEEDF_COURSE_ID, code: '467', familyId: 'seedf', name: 'Gestor em Políticas Públicas e Gestão Educacional — Administração',
    career: 'Assistência à Educação', referenceYear: 2022, programStatus: 'mapped',
    requirements: 'Referência 2022: diploma registrado de bacharelado em Administração, emitido por instituição reconhecida pelo MEC, e registro profissional no Sistema CFA/CRA em plena validade (Anexo III, item 3.2.1, alínea d).',
    requirementsSource: 'docs/sources/seedf/DODF-122-2022.pdf#page=127' },
  ...[['468','Arquivologia'],['469','Biblioteconomia'],['470','Comunicação Social'],['471','Contabilidade'],['472','Direito e Legislação'],['473','Economia'],['474','Nutrição'],['475','Psicologia'],['476','Serviço Social'],['477','Tecnologia da Informação']].map(([code, name]) => ({
    id: `seedf-gestor-${code}`, code, familyId: 'seedf', name: `Gestor — ${name}`, referenceYear: 2022,
    programStatus: 'not_mapped', requirements: 'Requisitos e programa específicos ainda não transcritos. Não presumir equivalência com Administração.'
  }))
];
export const SEEDF_SUBJECTS = program.map((s, i) => ({
  id: `seedf-${s.key}`, slug: `seedf-${s.key}`, courseId: SEEDF_COURSE_ID, blockId: `seedf-${s.group}`,
  name: s.name, order: i + 1, color: '#7c3aed', icon: s.group === 'discursiva' ? 'RD' : 'SE',
  description: `Anexo IV, item ${s.section} · referência 2022 · cargo 467`
}));
export const SEEDF_PROGRAM_NODES = program.flatMap(s => s.nodes.map((n, i) => ({
  ...n, id: `seedf22-${s.key}-${n.code.replaceAll('.', '-')}`, title: n.title,
  courseId: SEEDF_COURSE_ID, subjectId: `seedf-${s.key}`, groupId: s.group,
  officialSection: `${s.section}/${n.code}`, order: i + 1, ...SEEDF_SOURCE
})));
export const SEEDF_TOPICS = SEEDF_PROGRAM_NODES.filter(n => n.leaf);
export const SEEDF_RETIFICATIONS = [
  { number: '36/2022', impact: 'Delimita LC 840/2011; cria item 2.3 exclusivo da Assistência à Educação.', file: 'retificacao-36-2022.pdf' },
  { number: '44/2022', impact: 'Correção das discursivas e quantitativos por cargo; não altera programa do cargo 467.', file: 'retificacao-44-2022.pdf' },
  { number: '46/2022', impact: 'Regras de heteroidentificação; não altera programa do cargo 467.', file: 'retificacao-46-2022.pdf' },
  { number: '78/2022', impact: 'Comprovação de títulos e cronograma; sem alteração do programa do cargo 467.', file: 'retificacao-78-2022.pdf' },
  { number: '2/2023 e 3/2023', impact: 'Alterações de cronograma; sem mudança de conteúdo programático.', file: 'retificacao-3-2023.pdf' },
  { number: '11/2023', impact: 'Convocação para heteroidentificação e cronograma.', file: 'retificacao-11-2023.pdf' },
  { number: '15/2023', impact: 'Inclui ajuste proporcional das notas mínimas em caso de anulação de itens.', file: 'retificacao-15-2023.pdf' }
];
